/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ResultContext } from "./result";

const resultMessageVariants = cva("", {
  variants: {
    size: {
      default: "",
      sm: "text-sm",
      lg: "",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const ResultMessage: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  const { size } = React.useContext(ResultContext);

  return (
    <div
      className={cn(resultMessageVariants({ size }), className)}
      {...props}
    />
  );
};

export { ResultMessage, resultMessageVariants };
